import { render, staticRenderFns } from "./StatisticDetail.vue?vue&type=template&id=94aa2fb6&"
import script from "./StatisticDetail.vue?vue&type=script&lang=js&"
export * from "./StatisticDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports